export default "__VITE_ASSET__BAhf_LK___"